import dayjs, { type Dayjs } from '@bunce/dayjs'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$dayjs = dayjs

  // @ts-expect-error forced
  nuxtApp.vueApp.dayjs = dayjs

  return {
    provide: {
      dayjs,
    },
  }
})
